import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
var SummaryStep = function (_a) {
    var number = _a.number, title = _a.title, texts = _a.texts, children = _a.children;
    return (React.createElement("div", { className: "sui-flex sui-gap-2" },
        React.createElement("div", null,
            React.createElement(Typography, { variant: "body-lg", weight: "bold" },
                number,
                ".")),
        React.createElement("div", { className: "sui-flex sui-flex-col" },
            React.createElement(Typography, { variant: "body-lg", weight: "bold" }, title),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-3" }, texts === null || texts === void 0 ? void 0 : texts.map(function (text, i) { return (React.createElement(Typography, { variant: "body-base", key: i }, text)); })),
            children)));
};
export default SummaryStep;
